import { render, staticRenderFns } from "./TaskEditionPage.vue?vue&type=template&id=0ed685da&scoped=true&"
import script from "./TaskEditionPage.vue?vue&type=script&lang=ts&"
export * from "./TaskEditionPage.vue?vue&type=script&lang=ts&"
import style0 from "./TaskEditionPage.vue?vue&type=style&index=0&id=0ed685da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed685da",
  null
  
)

export default component.exports